import { IconPiano } from "@tabler/icons-react";
import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import MidiPlayer from "./javascript/midi-player";
import { Utils } from "./javascript/utils";
import ProjectPage from "./routing/ProjectPage";

const App: React.FC = () => {
	const [loadingInstrument, setLoadingInstrument] = React.useState<boolean>(false);

	const loadingInstrumentNotification = (instrumentName: string, loaded: boolean) => {
		if (loaded) {
			Utils.updateNotification(
				instrumentName,
				`Loaded ${instrumentName} instrument sound!`,
				undefined,
				"green",
				<IconPiano size={16} />,
				true,
				1000
			);
			setLoadingInstrument(false);
		} else {
			Utils.displayNotification(
				`Loading instrument sound: ${instrumentName}`,
				undefined,
				"blue",
				"loading",
				true,
				false,
				instrumentName
			);
			setLoadingInstrument(true);
		}
	};

	useEffect(() => {
		MidiPlayer.setLoadingInstrumentCallback(loadingInstrumentNotification);
	}, []);

	// Prevent scrolling issues on iOS devices
	useEffect(() => {
		const isIOS =
			/iPad|iPhone|iPod/.test(navigator.userAgent) ||
			(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

		if (!isIOS) {
			return;
		}

		const handleTouchMove = (event: TouchEvent) => {
			const target = event.target as HTMLElement | null;
			if (!target) return;

			if (!target.closest(".allow-vertical-scroll")) {
				event.preventDefault();
			}
		};

		document.addEventListener("touchmove", handleTouchMove, { passive: false });
		return () => {
			document.removeEventListener("touchmove", handleTouchMove);
		};
	}, []);

	return (
		<div className="app-root">
			<div className="app-scroll-container">
				<BrowserRouter>
					<AuthProvider>
						<ProjectPage loadingInstrument={loadingInstrument} />
					</AuthProvider>
				</BrowserRouter>
			</div>
		</div>
	);
};

export default App;
